export default "__VITE_ASSET__415323d0__"